import React from "react";
import GestureButton from "./GestureButton";
import { Action } from "../karaoke/actions";

export default function PrevControl({ activeAction, onTrigger, className }) {
  return (
    <GestureButton
      action={Action.PREV}
      label="Prev"
      emoji="☝️"
      activeAction={activeAction}
      onTrigger={onTrigger}
      className={className}
    />
  );
}
